import BaseService from "./BaseService";
import axios from "axios";

export default class UserService extends BaseService {

    constructor() {
        super('user');
    }

    recoverPassword(emailOrUsername) {
        return axios.put(`api/index.php/user/recover-password`, {emailOrUsername})
    }

    changePassword(password, passwordConfirm, token) {
        return axios.post(`api/index.php/user/change-password`, {password, passwordConfirm, token})
    }

    register(user) {
        return axios.post(`api/index.php/user`, user)
    }

    checkCF(cf, firstname, lastname, date) {
        return axios.post(`api/index.php/user/check-cf`, {codicefiscale: cf, firstname: firstname, lastname: lastname, datanascita: date})
    }

    checkEmail(email) {
        return axios.post(`api/index.php/user/check-email`, {value: email})
    }

    checkUsername(username) {
        return axios.post(`api/index.php/user/check-username`, {value: username})
    }
}
